import * as React from "react";

export const WebsiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5897 17.3032L11.4111 18.4817C9.78393 20.109 7.14575 20.109 5.51857 18.4817C3.89138 16.8545 3.89138 14.2164 5.51857 12.5892L6.69708 11.4107M17.3037 12.5892L18.4822 11.4107C20.1093 9.78349 20.1093 7.1453 18.4822 5.51812C16.855 3.89093 14.2168 3.89093 12.5897 5.51812L11.4111 6.69663M9.08371 14.9165L14.9171 9.08324"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
